import { Mission, MissionQuery } from '@edwin-group/cj-graphql';
import { create } from 'zustand';

interface MissionState {
  mission: Mission | null;
  setMission: (missionResult: MissionQuery) => void;
}

export const useMissionStore = create<MissionState>((set) => ({
  mission: null,
  setMission: (missionResult: MissionQuery) => {
    set({
      mission: missionResult?.fetchMissionBySlugAndSchoolAndSchoolYear as Mission,
    });
  },
}));
